<template>
  <div class="no-gutters">
    <div class="shadow" :class="type === 'dark' ? 'bg-default': ''">
      <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
        <div class="row align-items-center">
          <div id="errorNotification" class="col-md-12">
            <base-alert v-if="errorMessage != null" type="danger">
              <span class="alert-inner--text"> {{errorMessage}}</span>
              <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
                <span aria-hidden="true">&times;</span>
              </button>
            </base-alert>
            <base-alert v-if="successMessage != null" type="success">
              <span class="alert-inner--text"> {{successMessage}}</span>
              <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
                <span aria-hidden="true">&times;</span>
              </button>
            </base-alert>
          </div>
          <div class="col-md-3">
            <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
              {{_.startCase(currentProfile)}}
            </h3>
          </div>
          <div class="col-md-9 text-right">
             <base-button class="float-right ml-1" type="primary" size="sm"
                            @click.prevent="exportLiveStores">Export Live Stores</base-button>
             <div class="ml-1"></div>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <vuetable ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields"
                  :per-page="10" :css="css.table" pagination-path="" data-path="data"
                  @vuetable:load-error="onLoadError"
                  @vuetable:pagination-data="onPaginationData">

        </vuetable>
      </div>

      <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent': ''">
        <div class="pagination ui basic segment grid">
          <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
          </vuetable-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import axios from "axios";
import {
  mapState
} from 'vuex'
// import ApiInvoiceForm from '../System Profiles/ApiInvoiceForm.vue';

import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import secureStorage from '../../controllers/secureStorage';
import HTTPRequest from '../../controllers/httpRequest.js';
 import moment from "moment";

var component_x;

export default {
  name: 'profiles-table',
  props: {
    type: {
      type: String
    },
    title: String
  },
  components: {
    Vuetable,
    VuetablePagination,
    // ApiInvoiceForm
  },
  computed: {
    ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'serverType', 'profileId'])
  },
  data() {
    return {
      drawerVisible: false,
      accessRights: [],
      filterStatus: "",
      profileAction: "",
      errorMessage: null,
      successMessage: null,
      componentKey: 0,
      visible: false,
      availableFields: [],
      apiURL: "",
      fields: ["first_transaction_date", "site_name", "terminal_name"],
      liveStoreFields: ["first_transaction_date", "site_name", "terminal_name"],
      httpOptions: {
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-File"
        }
      },
        radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      css: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      },
      accountId: 0
    }
  },
  watch: {
    currentApiURL: function () {
      this.$refs.vuetable.resetData()
      this.apiURL = this.endPoint + 'terminals/get_pos_live_terminals'
    },
    parameters: function () {
      // this.apiURL = this.currentApiURL
      // this.apiURL = this.apiURL + this.parameters
      this.apiURL = this.endPoint + 'terminals/get_pos_live_terminals' + this.parameters
      this.$refs.vuetable.selectedTo = []
      this.checkedItems = []
    }
  },
  methods: {
    formatUpdatedAt(value) {
      if (!value) {
          return "";
      }
      let formattedDate = moment(value).format("YYYY-MM-DD HH:mm:ss A");
      return formattedDate;
    },
    refreshPage() {
      this.onClose()
      this.$refs.vuetable.refresh()
      this.successMessage = "Successful Operation"
      this.errorMessage = null
    },
    onClose() {
      this.errors = [];
      this.drawerVisible = false
      this.visible = false
      this.componentKey++
    },
    removeMessage(type) {
      if (type == 'error')
        this.errorMessage = null
      else
        this.successMessage = null
    },
    // async showActionDrawer(action) {
    //   this.profileAction = action
    //   this.visible = true
    // },
    async onPaginationData(paginationData) {
      // await axios({
      //     method: 'PUT',
      //     url: this.endPoint.split("/api")[0] + "/api/v2/backend_sessions/" + secureStorage.getItem("sessionId") + "/update_timestamp",
      //     headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
      // })
      this.$refs.pagination.setPaginationData(paginationData);
    },
    async onLoadError(error) {
      // request for new token or reauthenticate
      if (error.response.status == 401) {
        var auth_response = await HTTPRequest.authenticate(component_x.endPoint)
        if (auth_response["status"] == "Ok") {
          this.$router.go();
        } else {
          alert("Cannot get access token. Please login again.")
          this.$router.push("/")
        }
      } else {
        if(error.response.data.error == "Session expired"){
          alert("Session is already expired. Please login again.")
          document.getElementById("logoutButton").click()
        }
      }
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    exportLiveStores() {
      var payload = {};
      var baseUrl = this.endPoint + 'terminals' + "/download?file_type=csv&profile=live_store_list";
      payload["type"] = "all";
      payload["fields"] = this.liveStoreFields;

      axios({
        url: baseUrl,
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"
        },
        data: payload,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "live_store_list.csv");
        document.body.appendChild(link);
        link.click();
        this.onClose();
        this.successMessage = "Download successful";
      });
    },
    async showActionDrawer(action) {
      this.profileAction = action;
      this.drawerVisible = true;
    },
    download() {
      var payload = {};
      var additional_parameters = "";
      // var baseUrl = this.currentApiURL + "/download?file_type=csv";
      var baseUrl = this.endPoint + 'terminals' + "/download?file_type=csv&profile=pos_version";
      if (this.filterStatus == "0") {
        // All
        payload["type"] = "all";
      } else if (this.filterStatus == "1") {
        // Current Page
        var ids = this.$refs.vuetable.tableData.map(({ terminal_id }) => terminal_id)
        console.log(ids)
        payload["type"] = "current_page";
        if (ids == 0) {
          this.errors.push('No Record(s)');
          return;
        } else {
          payload["ids"] = ids
        }
      }  else {
        // Filtered
        payload["type"] = "filtered";
        additional_parameters = this.parameters;
      }

      var exportFields = this.fields;
      var cbIndex = this.fields.indexOf("__checkbox");
      if (cbIndex > -1) exportFields.splice(cbIndex, 1);
      var actionIndex = this.fields.indexOf("__slot:actions");
      if (actionIndex > -1) exportFields.splice(actionIndex, 1);

      payload["fields"] = exportFields;
      additional_parameters = additional_parameters.replace("?", "&");

      axios({
        url: baseUrl + additional_parameters,
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"
        },
        data: payload,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "pos_version.csv");
        document.body.appendChild(link);
        link.click();
        this.onClose();
        this.filterStatus = null;
        this.successMessage = "Download successful";
      });
    },
  },
  mounted: function () {
    component_x = this;
    this.accessRights = this.$attrs.accessRights;
    this.accountId = secureStorage.getItem("accountId")
    let defaultSiteId = secureStorage.getItem("defaultSiteId");
    // this.apiURL = this.currentApiURL + this.parameters
    this.apiURL = this.endPoint + 'terminals/get_pos_live_terminals?account_id=' + this.accountId + '&site_id=' + defaultSiteId + this.parameters
    console.log('live terminals table mounted')
    console.log('this.apiURL ', this.apiURL )
  }
}
</script>

<style>
</style>